import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { useFormik } from 'formik'

import { _object } from 'utils/interfaces'
import { Button, InputField, TextArea } from 'components/form-inputs'
import { categoryService } from 'services'
import * as yup from 'yup'

const EditCategory = () => {
  const { id } = useParams()
  const [categories, setCategories] = useState<_object>({})

  useEffect(() => {

    categoryService.CategoryDetails(id).then((results: _object) => {
      setCategories(results)
    })
  }, [id])

  const formik: any = useFormik({
    initialValues: {
      name: categories?.name || '',
      description: categories?.description || '',
      home_page_display: categories?.home_page_display || true,
      top_selling: categories?.top_selling || false
    },
    validationSchema: yup.object({ name: yup.string().label('Category Name').required() }),
    enableReinitialize: true,
    onSubmit: async (values) => {
      if (id) {
        await categoryService.UpdateCategory(id, values)
      } else {
        const response = await categoryService.createCategory(values)
        if (response.error === false) {
          formik.resetForm()
        }
      }
    }
  })

  return (
    <>
      <div className="mb-6">
        <h1 className="mb-1 text-2xl font-semibold">
          {id ? 'Edit Category' : 'Add Category'}
        </h1>
      </div>
      <div className="">
        <div className="">
          <form onSubmit={formik.handleSubmit}>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <div className="mb-4">
                  <InputField
                    label='Category Name'
                    placeholder='Category name'
                    name='name'
                    onChange={formik.handleChange}
                    value={formik.values.name}
                    required
                  />
                </div>
                <div className="mb-4">
                  <label className="mb-2 block text-sm font-medium text-gray-900">Home Page Display </label>
                  <div className="flex items-center gap-4 text-sm">
                    <label className="flex items-center gap-2">
                      <input
                        type="radio"
                        name="home_page_display"
                        value="true"
                        checked={formik.values.home_page_display === true || formik.values.home_page_display === 'true'}
                        onChange={() => formik.setFieldValue('home_page_display', true)}
                      />
                      Yes
                    </label>
                    <label className="flex items-center gap-2">
                      <input
                        type="radio"
                        name="home_page_display"
                        value="false"
                        checked={formik.values.home_page_display === false || formik.values.home_page_display === 'false'}
                        onChange={() => formik.setFieldValue('home_page_display', false)}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className="mb-4">
                  <label className="mb-2 block text-sm font-medium text-gray-900">Top Selling </label>
                  <div className="flex items-center gap-4 text-sm">
                    <label className="flex items-center gap-2">
                      <input
                        type="radio"
                        name="top_selling"
                        value="true"
                        checked={formik.values.top_selling === true || formik.values.top_selling === 'true'}
                        onChange={() => formik.setFieldValue('top_selling', true)}
                      />
                      Yes
                    </label>
                    <label className="flex items-center gap-2">
                      <input
                        type="radio"
                        name="top_selling"
                        value="false"
                        checked={formik.values.top_selling === false || formik.values.top_selling === 'false'}
                        onChange={() => formik.setFieldValue('top_selling', false)}
                      />
                      No
                    </label>
                  </div>
                </div>
                <div className="mb-4">
                  <TextArea
                    className='bg-gray-50'
                    label='Description'
                    placeholder='Description'
                    name='description'
                    onChange={formik.handleChange}
                    value={formik.values.description}
                  />
                </div>
                <div>
                  <Button
                    label="Save changes"
                    type="submit"
                    className="cursor mt-4 flex w-full justify-center rounded-lg bg-purple-900 py-2 text-center text-sm text-white transition hover:bg-purple-950 disabled:opacity-50"
                    disabled={!formik.isValid}
                  />
                </div>
              </div>
              <div></div>
            </div>
          </form>
        </div>


      </div>
    </>
  )
}

export default EditCategory
